import { useQuery } from "react-query";

import { useDnmRoleMappings } from "./useDnmRoleMappings";

export const useGetDnmRoleMappings = () => {
  const { getRoleMappings } = useDnmRoleMappings();

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["getDnmRoleMappings"],
    queryFn: () => getRoleMappings(),
  });
  return { data: data?.data, isLoading, isError, refetch };
};
